<style>
  .example-full-width {
    width: 100%;
  }
  button {
    background-color: #ff9800;
  }
  .settled{
    width: 20px;
  }
i {
  float: right;
}
  .mat-dialog-actions {
    padding: 3px 0px 27px !important;
    display: flex;
    flex-wrap: wrap;
    min-height: 52px;
    align-items: center;
    margin-bottom: none !important;
}

</style>

<div class="container dialog" >
  <i mat-dialog-close class="arrow-cursor">
    <mat-icon mat-icon-button matSuffix>clear</mat-icon>
</i>

  <h1 mat-dialog-title>APPLY NOW </h1>

  <form [formGroup]="applyNow" autocomplete="off" fxLayout="column">
    <mat-form-field >
      <mat-label> Full Name</mat-label>
      <input matInput formControlName="fullName" class="input" required/>
      <mat-icon matSuffix>person</mat-icon>
     
      <mat-error *ngIf="name.invalid">{{ getNameError() }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" formControlName="email" required/>
      <mat-icon matSuffix>email</mat-icon>
      <mat-error>Email is required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input matInput placeholder="+91" formControlName="phone" required/>
      <mat-icon matSuffix>phone</mat-icon>
      <mat-error>Phone is required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Course</mat-label>
      <mat-select matNativeControl required formControlName="course" required>
        <mat-option value="Salesforce Administration Track">Salesforce Administration Track</mat-option>
        <mat-option value="Salesforce Developer Track">Salesforce Developer Track</mat-option>
        <mat-option value="Vlocity Developer Track">Vlocity Developer Track</mat-option>
        <mat-option value="Mule Soft">Mule Soft</mat-option>
        <mat-option value="Marketing Cloud">Mareting Cloud</mat-option>
        <mat-option value="Service Cloud">Service Cloud</mat-option>
        <mat-option value="Sales Cloud">Sales Cloud</mat-option>
        <mat-option value="Health Cloud">Health Cloud</mat-option>


      </mat-select>
    </mat-form-field>
  </form>
  <div mat-dialog-actions class="submit_button">
    <button mat-raised-button mat-dialog-close (click)="submitForm()" [disabled]="applyNow.invalid" color="warn">
      Request a callback
    </button>
    <button mat-raised-button color="warn" mat-dialog-close>Cancel</button>
  </div>

</div>